import type { HTMLAttributes, ReactNode } from "react";

export interface EyebrowProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

/**
 * Surtitre mono majuscule espacé (ex : "Pilotage · Vue générale", "Domaine").
 * Sert à étiqueter une section ou bloc avec un libellé secondaire discret.
 */
export function Eyebrow({ className = "", children, ...rest }: EyebrowProps) {
  const composed = ["eyebrow", className].filter(Boolean).join(" ");
  return (
    <div className={composed} {...rest}>
      {children}
    </div>
  );
}
